<template>
  <div class="bg_box">
    <div class="title_box">
      <div class="bannerTitle">保彼通数据大屏</div>
      <NowTime class="time_box"/>
    </div>

    <!-- 账号登录 -->
    <div class="center_box" v-if="num === 1">
      <div class="center_box_l" :class="{ 'center_bg': num === 1 }" @click="num_clk(1)">账号登录</div>
      <div class="center_box_r" :class="{ 'center_bg': num === 2 }" @click="num_clk(2)">验证码登录</div>
      <div class="login_input_box">
        <el-form :model="from" :rules="rules" ref="accountForm">
          <el-form-item prop="username">
            <el-input class="login_input" v-model="from.username" placeholder="请输入账号信息"></el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input class="login_input" v-model="from.password" show-password placeholder="请输入密码"></el-input>
          </el-form-item>
          <el-form-item prop="captcha_code">
            <div style="display: flex; width: 100%;">
              <el-input class="login_input w_330" v-model="from.captcha_code" placeholder="请输入验证码"></el-input>
              <div class="login_input w_178">
                <img class="login_input_box_img" @click="tableInit" :src="captcha_image" alt="">
              </div>
              <img class="login_input_remove" @click="tableInit" src="../../assets/remove.png" mode="scaleToFill"/>
            </div>
          </el-form-item>
          <div class="dele_box" @click="num_clk(3)">忘记密码?</div>
          <!-- 登录按钮 -->
          <div class="login_btn" @click="submitForm('accountForm')">
            立即登录
          </div>
          <div class="login_txt">版权所有 © 2025 杭州优艾弗欧信息科技有限公司</div>
        </el-form>
      </div>
    </div>

    <!-- 验证码登录 -->
    <div class="center_box" v-if="num === 2">
      <div class="center_box_l" :class="{ 'center_bg': num === 1 }" @click="num_clk(1)">账号登录</div>
      <div class="center_box_r" :class="{ 'center_bg': num === 2 }" @click="num_clk(2)">验证码登录</div>
      <div class="login_input_box">
        <el-form :model="from" :rules="rules" ref="smsForm">
          <el-form-item prop="phone">
            <el-input class="login_input" v-model="from.phone" maxlength="11" placeholder="请输入手机号"></el-input>
          </el-form-item>
          <el-form-item prop="code">
            <div class="login_input flex_box">
              <el-input class="login_input_w" v-model="from.code" placeholder="请输入手机验证码"></el-input>
              <div class="login_input_txt" @click="get_data">获取验证码</div>
            </div>
          </el-form-item>
          <el-form-item prop="captcha_code">
            <div style="display: flex; width: 100%;">
              <el-input class="login_input w_330" v-model="from.captcha_code" placeholder="请输入图形验证码"></el-input>
              <div class="login_input w_178">
                <img class="login_input_box_img" @click="tableInit" :src="captcha_image" alt="">
              </div>
              <img class="login_input_remove" @click="tableInit" src="../../assets/remove.png" mode="scaleToFill"/>
            </div>
          </el-form-item>
          <div class="dele_box" @click="num_clk(3)">忘记密码?</div>
          <!-- 登录按钮 -->
          <div class="login_btn" @click="submitForm('smsForm')">
            立即登陆
          </div>
          <div class="login_txt">版权所有 © 2025 杭州优艾弗欧信息科技有限公司</div>
        </el-form>
      </div>
    </div>

    <!-- 忘记密码 -->
    <div class="center_box2" v-if="num === 3">
      <div class="center_box_t">忘记密码</div>
      <div class="login_input_box">
        <el-form :model="from" :rules="rules" ref="resetForm">
          <el-form-item prop="phone">
            <el-input class="login_input" v-model="from.phone" maxlength="11" placeholder="请输入手机号"></el-input>
          </el-form-item>
          <el-form-item prop="code">
            <div class="login_input flex_box">
              <el-input class="login_input_w" v-model="from.code" placeholder="请输入手机验证码"></el-input>
              <div class="login_input_txt" @click="get_data">获取验证码</div>
            </div>
          </el-form-item>
          <el-form-item prop="new_password">
            <el-input class="login_input" v-model="from.new_password" show-password
                      placeholder="请输入新密码"></el-input>
          </el-form-item>
          <el-form-item prop="confirm_password">
            <el-input class="login_input" v-model="from.confirm_password" show-password
                      placeholder="请再次输入新密码"></el-input>
          </el-form-item>
          <div class="dele_box" @click="num_clk(1)"><span>已有账号，</span> <span
              style="color: #FCCA01;">立即登录 ></span></div>
          <!-- 注册按钮 -->
          <div class="sure_btn" @click="submitForm('resetForm')">
            确认
          </div>
          <div class="login_txt">版权所有 © 2025 杭州优艾弗欧信息科技有限公司</div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import * as Ajax from '@/api/login';
import NowTime from '@/components/nowTime'

export default {
  components: {
    NowTime
  },
  data() {
    // 自定义验证规则
    const validatePhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入手机号'));
      }
      if (!/^1[3-9]\d{9}$/.test(value)) {
        return callback(new Error('请输入正确的手机号'));
      }
      callback();
    };

    const validatePassword = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入密码'));
      }
      if (value.length < 6 || value.length > 20) {
        return callback(new Error('密码长度在6-20个字符之间'));
      }
      callback();
    };

    const validateConfirmPassword = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请再次输入密码'));
      }
      if (value !== this.from.new_password) {
        return callback(new Error('两次输入密码不一致'));
      }
      callback();
    };

    const validateCaptcha = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入验证码'));
      }
      if (value.length !== 4) {
        return callback(new Error('验证码长度为4位'));
      }
      callback();
    };

    const validateCode = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入验证码'));
      }
      if (value.length !== 6) {
        return callback(new Error('验证码长度为6位'));
      }
      callback();
    };

    return {
      num: 1,
      loading: false,
      from: {
        phone: '',
        username: '',
        password: '',
        captcha_key: '',
        captcha_code: '',
        code: '',
        new_password: '',
        confirm_password: ''
      },
      captcha_image: '',
      rules: {
        username: [
          {required: true, message: '请输入账号', trigger: 'blur'},
          {min: 4, max: 20, message: '长度在4到20个字符', trigger: 'blur'}
        ],
        password: [
          {validator: validatePassword, trigger: 'blur'}
        ],
        phone: [
          {validator: validatePhone, trigger: 'blur'}
        ],
        code: [
          {validator: validateCode, trigger: 'blur'}
        ],
        captcha_code: [
          {validator: validateCaptcha, trigger: 'blur'}
        ],
        new_password: [
          {validator: validatePassword, trigger: 'blur'}
        ],
        confirm_password: [
          {validator: validateConfirmPassword, trigger: 'blur'}
        ]
      }
    }
  },
  methods: {
    // 提交表单前验证
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.login_clk();
        } else {
          return false;
        }
      });
    },

    tableInit() {
      this.loading = true;
      Ajax.captcha()
          .then((res) => {
            console.log(res)
            this.from.captcha_key = res.data.key
            this.captcha_image = res.data.image
          })
          .finally(() => {
            this.loading = false;
          });
    },

    async login_clk() {
      try {
        if (this.num === 1) {
          const res = await Ajax.authlogin(this.from)
          if (res.code === 200) {
            console.log(res)
            window.localStorage.setItem('token', res.data.token)
            window.localStorage.setItem('userinfo', JSON.stringify(res.data.info))
            this.$router.replace('/')
          }
        } else if (this.num === 2) {
          const res = await Ajax.authsmsLogin(this.from)
          if (res.code === 200) {
            console.log(res)
            window.localStorage.setItem('token', res.data.token)
            window.localStorage.setItem('userinfo', JSON.stringify(res.data.info))
            this.$router.replace('/')
          }
        } else if (this.num === 3) {
          const res = await Ajax.authresetPasswordBySms(this.from)
          if (res.code === 200) {
            console.log(res)
            this.$message.success('密码重置成功！')
            this.num_clk(1)
          }
        }
      } catch (error) {
        this.tableInit()
        // this.$message.error(error.message || '操作失败');
      }
    },

    async get_data() {
      try {
        // 验证手机号
        if (!this.from.phone) {
          this.$message.error('请输入手机号');
          return;
        }
        if (!/^1[3-9]\d{9}$/.test(this.from.phone)) {
          this.$message.error('请输入正确的手机号');
          return;
        }

        const res = await Ajax.smssend({phone: this.from.phone})
        if (res.code === 200) {
          this.$message.success('验证码发送成功');
          // 这里可以添加倒计时逻辑
        }
      } catch (error) {
        this.$message.error(error.message || '验证码发送失败');
      }
    },

    getFormattedDate(num) {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      const dateStr = `${year}-${month}-${day}`
      const weekdays = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];
      const weekday = weekdays[now.getDay()];
      const hours = String(now.getHours()).padStart(2, '0');
      const minutes = String(now.getMinutes()).padStart(2, '0');
      const seconds = String(now.getSeconds()).padStart(2, '0');
      const timeStr = `${hours}:${minutes}:${seconds}`;

      if (num === 1) {
        return `时间`;
      } else if (num === 2) {
        return ` ${dateStr}`;
      } else if (num === 3) {
        return ` ${weekday}`;
      } else if (num === 4) {
        return ` ${timeStr}`;
      }
    },

    num_clk(e) {
      this.num = e
      this.from.phone = ''
      this.from.username = ''
      this.from.password = ''
      this.from.code = ''
      this.from.new_password = ''
      this.from.confirm_password = ''


      this.$nextTick(() => {
        // 重置表单验证
        if (e === 1 && this.$refs.accountForm) {
          this.$refs.accountForm.resetFields();
          this.$refs.accountForm.clearValidate(); // 清除验证错误提示
        } else if (e === 2 && this.$refs.smsForm) {
          this.$refs.smsForm.resetFields();
          this.$refs.smsForm.clearValidate(); // 清除验证错误提示
        } else if (e === 3 && this.$refs.resetForm) {
          this.$refs.resetForm.resetFields();
          this.$refs.resetForm.clearValidate(); // 清除验证错误提示
        }
      })
    }
  },
  created() {
    this.tableInit()
  }
}
</script>

<style lang="scss" scoped>

::v-deep(.el-form-item__error) {
  font-size: 20px;
  transform: translate(0, -10px);
}

.bg_box {
  position: relative;
  width: 100%;
  height: 100vh;
  background-image: url(../../assets/login_bg.png);
  background-size: 100% 100vh;
}

.title_box {
  display: flex;
  justify-content: right;
  padding-top: 7px;
  width: 100%;
  height: 80px;
  background: url(../../assets/_s-top_image_tab_bg.png) no-repeat center top;
  background-size: 1000px 80px;

  .bannerTitle {
    position: absolute;
    left: 50%;
    transform: translate(-50%, 0);
    font-size: 40px;
    font-weight: 700;
    color: white;
  }
}

.time_box {
  width: 460px;
  height: 40px;
  margin-top: 10px;
  margin-right: 140px
}

.center_box {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  width: 822px;
  height: 658px;
  padding-top: 40px;
  padding-bottom: 0px;
  background-image: url(../../assets/login_center2.png);
  background-size: 100% 100%;
}

.center_box2 {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  width: 822px;
  height: 728px;
  background-image: url(../../assets/login_center2.png);
  background-size: 100% 100%
}

.center_box_t {
  margin-left: 161px;
  position: absolute;
  top: 4px;
  width: 500px;
  height: 64px;
  line-height: 64px;
  text-align: center;
  font-weight: 600;
  font-size: 26px;
  color: #FFFFFF;
  background-image: url(../../assets/login_center_t.png);
  background-size: 500px 64px;
}

.center_box_l {
  cursor: pointer;
  width: 230px;
  height: 64px;
  background-image: url(../../assets/login_center_l.png);
  background-size: 230px 64px;
  position: absolute;
  top: 4px;
  left: 160px;
  line-height: 64px;
  text-align: center;
  font-weight: 400;
  font-size: 26px;
  color: #73CFF2;
}

.center_box_r {
  cursor: pointer;
  width: 230px;
  height: 64px;
  background-image: url(../../assets/login_center_l.png);
  background-size: 230px 64px;
  position: absolute;
  top: 4px;
  right: 160px;
  line-height: 64px;
  text-align: center;
  font-weight: 400;
  font-size: 26px;
  color: #73CFF2;
}

.center_bg {
  background-image: url(../../assets/login_center_r.png) !important;
}

.login_input {
  margin-bottom: 20px;
  width: 528px;
  height: 60px;
  line-height: 60px;
  padding: 0 50px;
  font-weight: 600;
  font-size: 24px;

  background-size: 628px 60px;
  background-image: url(../../assets/login_input.png);
}

::v-deep .el-input__inner {
  padding: 0;
  height: 60px !important;
  line-height: 60px;
  font-size: 24px;
  color: #FFFFFF !important;
  background: none !important;
  border: none !important;
}

.w_330 {
  margin-right: 32px;
  background-size: 328px 60px !important;
  width: 228px !important;
}

.w_178 {
  padding: 0 !important;
  margin-right: 32px;
  background-size: 178px 60px;
  width: 178px !important;
}

.login_input_box {
  margin-left: 97px;
  margin-top: 84px;
  width: 628px;
}

.login_input_remove {
  margin-top: 15px;
  margin-right: 15px;
  width: 30px;
  height: 30px;
  cursor: pointer;
}

.login_input_box_img {
  width: 178px;
  height: 60px;
  cursor: pointer;
}

.dele_box {
  font-weight: 400;
  font-size: 20px;
  color: #00D2FF;
  height: 19px;
  line-height: 19px;
  margin-top: -10px;
  cursor: pointer;
}

.login_btn {
  cursor: pointer;
  margin-top: 47px;
  margin-left: 19px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 591px;
  height: 72px;
  background-size: 591px 72px;
  background-image: url(../../assets/login_btn.png);
  color: white;
  font-weight: 700;
  font-size: 30px;
}

.sure_btn {
  cursor: pointer;
  margin-top: 37px;
  margin-left: 19px;
  width: 591px;
  height: 72px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-size: 591px 72px;
  background-image: url(../../assets/login_btn.png);
  color: white;
  font-weight: 700;
  font-size: 30px;
}

.login_txt {
  margin-top: 20px;
  text-align: center;
  font-weight: 400;
  font-size: 18px;
  color: #00D2FF;
}


.flex_box {
  display: flex;
  justify-content: space-between;
}

.login_input_w {
  height: 60px;
  line-height: 60px;
  width: 400px;
}

.login_input_txt {
  font-weight: 400;
  font-size: 24px;
  color: #FFCC00;
  cursor: pointer;
}

.el-input {
  height: 60px !important;
  line-height: 60px !important;
}

::v-deep .el-icon-view {
  line-height: 60px !important;
  font-size: 24px !important;
}
</style>